import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import FooterWrapper from '../components/FooterWrapper';

const FAQ = () => {
  const faqData = [
    {
      question: "Wie ist der Ablauf des kostenlosen Erstgesprächs?",
      answer: "Im Erstgespräch lernen wir Ihr Unternehmen, Ihre Ziele und aktuellen Herausforderungen kennen. Wir zeigen Ihnen erste Einsatzfelder für KI und geben eine klare Empfehlung für die nächsten Schritte."
    },
    {
      question: "Wir wollen mit KI starten, wissen aber nicht wie?",
      answer: "Genau dafür sind wir da. Wir begleiten Sie von der ersten Idee über kleine Pilotprojekte bis hin zu einer nachhaltigen KI-Strategie. So starten Sie strukturiert und ohne Risiko."
    },
    {
      question: "Ich weiß nicht, wie wir KI bei uns im Betrieb einsetzen können?",
      answer: "Keine Sorge. Gemeinsam analysieren wir Ihre Prozesse und identifizieren Stellen, an denen KI echten Mehrwert bringt – ohne unnötigen Hype oder komplizierte Umstellungen."
    },
    {
      question: "Können auch kleinere Unternehmen von KI profitieren?",
      answer: "Absolut! Gerade kleine und mittelständische Unternehmen profitieren von Automatisierungen, da sie mit begrenzten Ressourcen arbeiten. KI macht Prozesse schlanker und erhöht die Wettbewerbsfähigkeit."
    },
    {
      question: "Wo und wie kann KI im Alltag eingesetzt werden?",
      answer: "KI kann in vielen Bereichen unterstützen: von Büro- und Verwaltungsaufgaben über Marketing, Vertrieb und HR bis hin zu Kundenservice und Projektmanagement."
    },
    {
      question: "Wie kann ich mit KI die Produktivität steigern?",
      answer: "KI übernimmt zeitintensive, wiederkehrende Aufgaben, analysiert Daten schneller und unterstützt bei Entscheidungen. Dadurch gewinnen Ihre Mitarbeitenden mehr Zeit für kreative und wertschöpfende Tätigkeiten."
    },
    {
      question: "Welche Branchen oder Prozesse profitieren besonders stark von KI?",
      answer: "Besonders profitieren Branchen mit vielen Routineaufgaben oder großen Datenmengen – etwa Dienstleistungen, Handel, Produktion, Logistik, Marketing, HR und Vertrieb."
    },
    {
      question: "Wie läuft die Integration von KI in bestehende Systeme ab?",
      answer: "Wir prüfen Ihre aktuelle Systemlandschaft, identifizieren Schnittstellen und entwickeln eine Lösung, die sich nahtlos in Ihre Prozesse einfügt. Das sorgt für reibungslose Abläufe ohne unnötige Umbrüche."
    },
    {
      question: "Wie lange dauert es, bis erste Ergebnisse mit KI sichtbar werden?",
      answer: "Erste Erfolge sind oft schon nach wenigen Wochen sichtbar – etwa durch kleine Automatisierungen oder Pilotprojekte. Größere Projekte dauern länger, liefern dafür nachhaltigen Nutzen."
    },
    {
      question: "Welche Investitionen muss ich für KI-Lösungen einplanen?",
      answer: "Das hängt von Ihren Zielen und der Komplexität ab. Wir bieten skalierbare Lösungen – von kostengünstigen Pilotprojekten bis hin zu umfassenden Automatisierungen. So behalten Sie die volle Kostenkontrolle."
    },
    {
      question: "Welche Förderungen zu KI gibt es?",
      answer: "Es gibt verschiedene staatliche Förderprogramme, die je nach Branche, Region und Unternehmensgröße greifen. Wir helfen Ihnen, passende Zuschüsse zu finden und erfolgreich zu beantragen."
    },
    {
      question: "Wie sicher ist KI im Hinblick auf Datenschutz und DSGVO?",
      answer: "Datensicherheit hat oberste Priorität. Wir achten auf DSGVO-Konformität, setzen auf sichere Anbieter und entwickeln individuelle Sicherheitskonzepte, damit Ihre Daten geschützt bleiben."
    },
    {
      question: "Arbeitet KI die Mitarbeitenden „weg“ oder unterstützt sie eher?",
      answer: "KI ersetzt keine Menschen, sondern unterstützt sie. Sie entlastet von monotonen Aufgaben und schafft Freiräume für wertschöpfende Tätigkeiten. Ziel ist immer: Unterstützung statt Ersatz."
    },
    {
      question: "Viele unserer Mitarbeitenden haben Respekt vor KI, wie kann ich mein Team bestmöglich vorbereiten?",
      answer: "Durch transparente Kommunikation und praxisnahe Workshops. Mitarbeitende lernen, KI als Unterstützung zu nutzen und Vertrauen in die Technologie aufzubauen."
    },
    {
      question: "Bieten Sie maßgeschneiderte Lösungen oder Standard-Tools an?",
      answer: "Wir entwickeln individuelle Lösungen, die exakt zu Ihrem Unternehmen passen. Dabei setzen wir auf bewährte Technologien, die wir flexibel an Ihre Anforderungen anpassen – keine Einheitslösungen."
    }
  ];

  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="min-h-screen bg-black-pure flex flex-col">
      
      <section className="relative z-10 bg-black-pure pt-48 pb-24 overflow-hidden sm:overflow-visible">
        {/* Radial Gradient Blur - Top Left */}
        <div
          aria-hidden="true"
          className="pointer-events-none absolute left-0 top-0 -z-10 size-[706px] translate-x-[45%] translate-y-[-12%] rounded-full bg-[radial-gradient(50%_50%_at_50%_50%,rgba(100,115,140,.15),transparent)] xl:size-[596px] lg:size-[596px] sm:size-[466px]"
        />

        <div
          aria-hidden="true"
          className="pointer-events-none absolute right-0 bottom-0 -z-10 size-[706px] translate-x-[-50%] translate-y-[50%] rounded-full bg-[radial-gradient(50%_50%_at_50%_50%,rgba(100,115,140,.15),transparent)] xl:size-[596px] lg:size-[596px] sm:size-[466px]"
        />
        
        <div className="max-w-[825px] mx-auto px-4 relative z-10">
          <h1 className="font-calsans text-[36px] md:text-[46px] font-semibold text-white mb-8 leading-tight text-left">
            Häufig gestellte Fragen
          </h1>
          
          <div className="pt-16 pb-32 space-y-0">
            {faqData.map((item, index) => (
              <div 
                key={index} 
                className="faq-drawer"
              >
                <button
                  className={`faq-drawer__title py-6 block w-full text-left cursor-pointer text-sm md:text-base font-normal text-white font-geist relative pr-8 md:pr-8 ${
                    index === 0 ? 'border-t-[1px] border-[rgba(120,124,135,0.25)]' : ''
                  }`}
                  onClick={() => toggleAccordion(index)}
                  aria-expanded={openIndex === index}
                >
                  {item.question}
                  <motion.span 
                    className="faq-drawer__arrow absolute right-0 top-1/2 transform -translate-y-1/2 w-3 h-3"
                    animate={{ rotate: openIndex === index ? 315 : 135 }}
                    transition={{ 
                      duration: 0.2, 
                      ease: "easeInOut"
                    }}
                  >
                    <span className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-2 h-2 border-t border-r border-white"></span>
                  </motion.span>
                </button>
                
                <AnimatePresence>
                  {openIndex === index && (
                    <motion.div
                      className="faq-drawer__content-wrapper overflow-hidden border-b-[1px] border-[rgba(120,124,135,0.25)]"
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ 
                        height: { 
                          duration: 0.2, 
                          ease: "easeInOut"
                        },
                        opacity: { 
                          duration: 0.2
                        }
                      }}
                    >
                      <div className="pb-6 text-[#787c87] font-light font-geist text-sm md:text-base">
                        <p>{item.answer}</p>
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
                
                {/* Show bottom border when accordion is closed */}
                {openIndex !== index && (
                  <div className="border-b-[1px] border-[rgba(120,124,135,0.25)]"></div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
      
      <FooterWrapper />
    </div>
  );
};

export default FAQ;